import useStyles from "../styles";
import successCheckIcon from "../../../assets/images/svg/success.png";
import warningEmailIcon from "../../../assets/images/svg/email.png";
import { Icon } from "@iconify/react";
import Button from "../../../components/Button";

export const StudentModal = ({ isOpen, onClose, children }) => {
  const classes = useStyles();

  if (!isOpen) {
    return null;
  }

  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={classes.modalOverlay} onClick={onClose}>
      <div onClick={handleModalContentClick}>
        {children}
      </div>

    </div>
  );
};

export const SuccessModal = ({ onDone }) => {
  const classes = useStyles();

  return (
    <div className={classes.modalCard}>
      <div className={`${classes.iconWrapper} ${classes.successIconBg}`}>
        <img
          src={successCheckIcon}
          alt="Success"
          className={classes.iconImg}
        />
      </div>
      <h2 className={classes.heading}>Students added successfully</h2>
      <p className={classes.body}>
        Congratulations! You can now review these students in the Student Directory.
      </p>
      <div className={classes.modalFooterBtn}>
        <Button
          variant="primary"
          buttonSize="full"
          color="btndefault"
          onClick={onDone}
          buttonName="Done"
        />
      </div>
    </div>
  );
};

export const WarningModal = ({ onDownload }) => {
  const classes = useStyles();

  return (
    <div className={classes.modalCard}>
      <img
        src={warningEmailIcon}
        alt="Warning"
        className={classes.warningIconImg}
      />
      <h2 className={classes.heading}>Some emails not valid</h2>
      <p className={classes.body}>
        Some emails were invalid or missing required fields.
      </p>
      <button className={classes.modalFooter} onClick={onDownload}>
        <Icon icon="material-symbols:download" width="18" height="18" />
        Download file
      </button>
    </div>
  );
};
